//NG+
import { AppSettings } from "../app-settings";
import { UserSettingsService } from "./user-settings-service";

import { NGXLogger } from "ngx-logger";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { layerTypeName } from "../definitions";
import {  taskFileRSV  } from "../roles/settings-components/settings-definitions";
import { getExMessage, isArray, isObject } from "../map/map-utils";


export interface IDbStoreRegistrulSV {
    generateRsvPdf(spatiiVerziIds: number[]): Promise<taskFileRSV>;
    generateRsvPdfRange(startId: number, endId: number, tipRaport: string): Promise<taskFileRSV>;
}

export class DbStoreRegistrulSV implements IDbStoreRegistrulSV {

    constructor(
        private $http: HttpClient,
        private $log: NGXLogger,
        private settingsService: UserSettingsService) { }

    /**
     * Generate RSV PDF for specific spatii verzi IDs
     */
    public generateRsvPdf(spatiiVerziIds: number[]): Promise<taskFileRSV> {
        let result: taskFileRSV = {
            id: -1, fisier: '', stare: '',
            status: '', time: '', tip: ''
        };

        return this.$http.post(
            AppSettings.serverPath + '/rsvPdf/generate',
            { spatiiVerziIds: spatiiVerziIds },
            {
                headers: { 'Content-Type': 'application/json' },
                observe: "response"
            })
            .toPromise()
            .then((response) => {
                if (response.body && isObject(response.body)) {
                    let restsk = response.body as any;
                    try {
                        result.id = restsk.idTask || restsk.taskId || restsk.id || -1;
                        result.fisier = restsk.numeDoc || restsk.fisier || '';
                        result.stare = restsk.stare || restsk.message || '';
                        result.status = restsk.status || '';
                        result.tip = 'generare';
                    } catch (error) {
                        result.status = 'eroare';
                        result.stare = 'eroare extragere date task';
                        this.$log.error("eroare extragere date task RSV PDF", error);
                    }
                } else {
                    this.$log.error("eroare generare RSV PDF");
                    throw new Error("Eroare format obiect json");
                }
                return result;
            }).catch((reason) => {
                result.status = "eroare";
                result.stare = "eroare interogare rsvPdf/generate";
                if (reason.error && reason.error.message) {
                    result.stare = reason.error.message;
                } else if (reason.status && reason.statusText) {
                    result.stare = "status code: " + reason.status + " , text: " + reason.statusText;
                }
                this.$log.error("eroare generare RSV PDF", getExMessage(reason));
                return result;
            })
    }

    /**
     * Generate RSV PDF for a range of spatii verzi IDs
     */
    public generateRsvPdfRange(startId: number, endId: number, tipRaport: string): Promise<taskFileRSV> {
        let result: taskFileRSV = {
            id: -1, fisier: '', stare: '',
            status: '', time: '', tip: ''
        };

        return this.$http.post(
            AppSettings.serverPath + '/rsvPdf/generate',
            { startId: startId, endId: endId, tipTask: tipRaport },
            {
                headers: { 'Content-Type': 'application/json' },
                observe: "response"
            })
            .toPromise()
            .then((response) => {
                if (response.body && isObject(response.body)) {
                    let restsk = response.body as any;
                    try {
                        result.id = restsk.idTask || restsk.taskId || restsk.id || -1;
                        result.fisier = restsk.numeDoc || restsk.fisier || '';
                        result.stare = restsk.stare || restsk.message || '';
                        result.status = restsk.status || '';
                        result.tip = 'generare';
                    } catch (error) {
                        result.status = 'eroare';
                        result.stare = 'eroare extragere date task';
                        this.$log.error("eroare extragere date task RSV PDF range", error);
                    }
                } else {
                    this.$log.error("eroare generare RSV PDF range");
                    throw new Error("Eroare format obiect json");
                }
                return result;
            }).catch((reason) => {
                result.status = "eroare";
                result.stare = "eroare interogare rsvPdf/generate";
                if (reason.error && reason.error.message) {
                    result.stare = reason.error.message;
                } else if (reason.status && reason.statusText) {
                    result.stare = "status code: " + reason.status + " , text: " + reason.statusText;
                }
                this.$log.error("eroare generare RSV PDF range", getExMessage(reason));
                return result;
            })
    }
}